<!-- 查看/编辑食谱弹窗 -->
<template>
    <div>
        <el-dialog title="查看详情" :visible.sync="isShowCheck" top="100px" width="30%" custom-class="custom-dialog-class"
            @close="closeDialog">
            <div v-loading="isLoading" class="dialog-container">
                <el-form label-width="150px" :rules="rules">
                    <el-form-item label="菜肴名称：" prop="menuName">
                        <span>{{ contentObj.dishName }}</span>
                    </el-form-item>
                    <el-form-item label="饮食类型：" prop="dietType">
                        <div class="itemContainer">
                            <div class="item" v-for="(item, index) in dietTypeTxtList" :key="index">
                                {{ item }}
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="菜肴分类：" prop="foodType">
                        <span>{{ foodTypeTxt }}</span>
                    </el-form-item>
                    <el-form-item label="食材：" prop="material">
                        <el-table :data="contentObj.ingredientDTOS" max-height="250" width="200">
                            <el-table-column prop="ingredientName" align="center" label="食材名称" />
                            <el-table-column prop="proportion" align="center" label="比例" />
                            <el-table-column align="center" label="能量预估">
                                <template slot-scope="scope">
                                    <span>{{
                                        calcSingleEnergy(
                                            scope.row.proportion,
                                            scope.row.energy
                                        )
                                    }}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="dec">总能量预估{{ totalEnergy?.toFixed(2) || '' }}kcal/100g</div>
                    </el-form-item>
                    <el-form-item label="用餐时间：" prop="mealTime">
                        <div class="itemContainer">
                            <div class="item" v-for="(item, index) in mealTimeTxtList" :key="index">
                                {{ item }}
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="中医证型：" prop="syndromeType">
                        <span>{{ syndromeTypeTxt }}</span>
                    </el-form-item>
                    <el-form-item v-if="contentObj?.tcmText" label="中医食补文案补充：">
                        <span>{{ contentObj?.tcmText || '' }}</span>
                    </el-form-item>
                    <el-form-item label="单位转换：" prop="joinKcal">
                        <span>{{ contentObj.unitConversion ? `1g等于 ${contentObj.unitConversion} ml` : '未填写' }}</span>
                    </el-form-item>
                    <el-form-item label="是否计入能量：" prop="joinKcal">
                        <span>{{ contentObj.isCountEnergy === '1' ? '是' : '否' }}</span>
                    </el-form-item>
                </el-form>
            </div>
            <template #footer>
                <slot></slot> 
            </template>
        </el-dialog>
        <AddDialog :isLoading="isLoading"  :isOpen.sync="isShowEdit" :dietTypeList="dietTypeList" :foodTypeList="foodTypeList"
            :mealTimeList="mealTimeList" :syndromeTypeList="syndromeTypeList" :row="contentObj"
            :toggleOpen="closeDialog" :submitCallBack="closeDialog" @reEditCommit="reEditCommit" operType="reEdit" titlePro="重新提交">
            <template v-slot:default="slotProps">
                <el-button type="primary" @click="slotProps.submitForm('formRef')">重新提交</el-button>
                <el-button @click="closeDialog">取 消</el-button>
            </template>
        </AddDialog>
    </div>
</template>
<script>
import { get, post } from "@/api/http";
import { calcEnergy } from "@/utils";
import AddDialog from '../RecipeKnowledgeBase/addDialog.vue'
export default {
    name: "RecipeDialog",
    components: { AddDialog },
    props: {
        operType: {
            type: String,
            default: "check",
        },
        closeDialog: {
            type: Function,
            default: () => { },
        },
        content: {
            type: String,
            default: "",
        },
        rowId: {
            type: String,
            default: "",
        },
    },
    mounted() {
        this.fetchDietTypeList();
        this.fetchFoodTypeList();
        this.fetchMealTimeList();
        this.fetchSyndromeTypeList();
    },
    data() {
        return {
            isfetchDietTypeLoading: false,
            isfetchFoodTypeLoading: false,
            isfetchMealTimeListLoading: false,
            isfetchSyndromeTypeListLoading: false,
            contentObj: JSON.parse(this.content || "{}"),
            dietTypeList: [], // 饮食类型列表
            foodTypeList: [], // 菜肴分类列表
            mealTimeList: [], // 用餐时段列表
            syndromeTypeList: [], // 中医证型列表
            totalEnergy: 0,
            rules: {
                menuName: [{ required: true, message: "", trigger: "blur" }],
                dietType: [{ required: true, message: "", trigger: "blur" }],
                foodType: [{ required: true, message: "", trigger: "blur" }],
                material: [{ required: true, message: "", trigger: "blur" }],
                mealTime: [
                    { required: true, message: "请选择饮食类型", trigger: "change" },
                ],
            },
        };
    },
    computed: {
        isShowCheck() {
            return this.operType === "check";
        },
        isShowEdit() {
            return this.operType === "edit";
        },
        dietTypeTxtList() {
            if (this.dietTypeList?.length) {
                return this.contentObj?.dietType?.split(",")?.map((item) => {
                    return this.dietTypeList?.find((it) => it.dictKey === item)?.dictValue;
                });
            } else {
                return [];
            }
        },
        foodTypeTxt() {
            if (this.foodTypeList?.length) {
                return this.foodTypeList.find(
                    (item) => item.dictKey === this.contentObj?.dishCategory
                )?.dictValue;
            } else {
                return "";
            }
        },
        mealTimeTxtList() {
            if (this.mealTimeList?.length) {
                return this.contentObj?.mealPeriod?.split(",")?.map((item) => {
                    return this.mealTimeList?.find((it) => it.dictKey === item)?.dictValue;
                });
            } else {
                return [];
            }
        },
        syndromeTypeTxt() {
            return this.syndromeTypeList?.find(item => item.dictKey === this.contentObj?.tcmSyndromeType)?.dictValue || '';
        },
        isLoading() {
            return this.isfetchDietTypeLoading || this.isfetchFoodTypeLoading || this.isfetchMealTimeListLoading || this.isfetchSyndromeTypeListLoading;
        },
    },
    methods: {
        // 查询饮食类型
        async fetchDietTypeList() {
            try {
                this.isfetchDietTypeLoading = true;
                const result = await get("dictionary/type/diet_food_consistency");
                const { data = [] } = result || {};
                this.dietTypeList = data;
            } catch (error) {
                console.log(error);
            } finally {
                this.isfetchDietTypeLoading = false;
            }
        },
        // 查询菜肴分类
        async fetchFoodTypeList() {
            try {
                this.isfetchFoodTypeLoading = true;
                const result = await get("dictionary/type/diet_food_type");
                const { data = [] } = result || {};
                this.foodTypeList = data;
            } catch (error) {
                console.log(error);
            } finally {
                this.isfetchFoodTypeLoading = false;
            }
        },
        // 查询用餐时段
        async fetchMealTimeList() {
            try {
                this.isfetchMealTimeListLoading = true;
                const result = await get("dictionary/type/diet_meal_time");
                const { data = [] } = result || {};
                this.mealTimeList = data;
            } catch (error) {
                console.log(error);
            } finally {
                this.isfetchMealTimeListLoading = false;
            }
        },
        // 查询中医证型
        async fetchSyndromeTypeList() {
            try {
                this.isfetchSyndromeTypeListLoading = true;
                const result = await get("dictionary/type/diet_syndrome_type");
                const { data = [] } = result || {};
                this.syndromeTypeList = data;
            } catch (error) {
                console.log(error);
            } finally {
                this.isfetchSyndromeTypeListLoading = false;
            }
        },
        // 计算食材能量
        calcSingleEnergy(proportion, energy) {
            let allRation = 0;
            this.contentObj?.ingredientDTOS?.forEach((item) => {
                allRation += item.proportion;
            });
            const singleEnergy = calcEnergy(proportion, allRation, energy);
            /* 直接相加会触发无限循环 */
            setTimeout(() => {
                this.totalEnergy += singleEnergy;
            }, 100);
            return singleEnergy;
        },
        // 重新提交
        async reEditCommit(content = {}) {
            try {
                const params = {
                    id: this.rowId,
                    content: JSON.stringify(content)
                }
                const result = await post("/diet/audit/reSubmit", params);
                const { code } = result;
                if (code === "SUCCESS") {
                    this.$message.success("提交成功");
                    this.closeDialog(); // 关闭弹窗
                    this.$emit('fetchTableList');
                } else {
                    this.$message.error("提交失败，请重试！");
                }
            } catch (error) {
                console.log(error);
            }
        }
    },
};
</script>
<style lang="scss" scoped>
.itemContainer {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    .item {
        background-color: rgb(203, 226, 255);
        color: rgba(26, 124, 242);
        border-radius: 50px;
        padding: 0 8px;
        min-width: 60px;
        text-align: center;
    }
}
</style>
